// import store from 'redux/store';
// import { actions as notificationActions } from 'redux/domain/Notification';
/**
 * Settings needed to set default Notification found in the Navbar which uses the Material-UI
 * snackbar. Any component can display a mesage to the user by importing the
 * NotifcationActions and calling ShowNotification with these settings as parameters.
 * You need to provide the onRequestClose callback with the disableNotification action for
 * this to work. Otherwise the notification will keep popping open.
 */
class SnackbarSettings {
	/**
	 * Constructor for snackbar settings. Parameters are required fields.
	 * @param {boolean} open - set to true to open.
	 * @param {string} message - message to display (may be an array of strings)
	 */
	constructor(open = false, message = '') {
		// Required
		this.open = open;
		this.message = message;

		// Label for the action on the snackbar
		this.action = undefined;
		// number of milliseconds to wait before dismissing
		this.autoHideDuration = undefined;
		// Fired when the action button is touchtapped
		// function(event: object) => void
		// this.onActionTouchTap = undefined;
		// Fired when the SnackBar is requested to be closed by a click outside the snackbar or afer
		// the autohideduration expires.
		// Need to come back to figure out why this does not work.
		// this.onClose = () => store.dispatch(notificationActions.disableNotification);
	}
}

export default SnackbarSettings;
